module.exports = __webpack_public_path__ + "img/Weapon_286.0e7be432.png";